import React, { useEffect, useState } from 'react';
import SecondaryNavBar from 'Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from "../../../Components/LoadingOverlay/LoadingOverlay";
import { useSelector } from "react-redux";
import { getRemboursements } from "../../../api/demandeAcitService";
import { v4 as uuidv4 } from "uuid";
import PaginationWithTable from "../../../Components/PaginationWithTable/PaginationWithTable";
import { useNavigate } from "react-router-dom";
import { getDocumentSinistre, getDocumentsTicDoc, getPdfBase64 } from "../../../api/documentsGrcEvtService";
import { buildNumeroSinistre } from "../../../utils/metierUtils";
import Modal from "react-bootstrap/Modal";
import { displayBase64Pdf } from "../../../utils/fileUtils";
import moment from "moment/moment";
import DOMPurify from "dompurify";
import PdfModal from "../../../Components/PdfModal/PdfModal";
import Spinner from "../../../Components/Spinner/Spinner";
import { getUuid } from "../../../utils/formUtils";

export default function Remboursements() {

    const navigate = useNavigate()

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const CONF = window?.confPub
    const ROUTES = CONF?.ROUTES
    const UI_ACIT = CONF?.UI?.ACIT
    const PATTERNS = CONF?.PATTERNS
    const FORMULAIRE_ACIT = UI_ACIT?.FORMULAIRE
    const REFERENCES_ACIT = UI_ACIT?.REFERENCES
    const STATUT_DOSSIER = UI_ACIT?.REFERENCES?.STATUT_DOSSIER
    const TYPE_INDEMNITE = REFERENCES_ACIT?.TYPE_INDEMNITE
    const FAMILLE_MAINTIEN_SALAIRE = "MS"
    const FAMILLE_PREF_ACTIFS = "ID"

    const [disabledForm, setDisabledForm] =useState(true)
    const [remboursements, setRemboursements] = useState([])
    const [liensDocuments, setLiensDocuments] = useState([])
    const [liensDocumentTicDoc, setLiensDocumentTicDoc] = useState([])
    const [displayDocument, setDisplayDocument] = useState(false)
    const [pdf, setPdf] = useState({
        base64: null,
        loaded: false,
        titre: null,
        downloadName: null,
    })

    // FIXME Provisoir (enfin j'espère)
    const [displayDocuments, setDisplayDocuments] = useState(false)
    const [pdfsTitle, setPdfsTitle] = useState('')
    const [pdfs, setPdfs] = useState([])
    const [pdfsLength, setPdfLength] = useState(0)
    const [pdfsLoaded, setPdfLoaded] = useState(false)
    const [pdfsDonwloaded, setPdfDonwloaded] = useState(0)


    useEffect(() => {

        const fetchRemboursement = async () => {

            let seenIds = new Set()

            try {

                let remboursementsFromServer = await getRemboursements(contrat?.numeroContrat, detailPersonne?.idPersInfinite, contrat?.produit)

                if (remboursementsFromServer?.length > 0) {

                    remboursementsFromServer.forEach(remboursement => {

                        if (!seenIds.has(remboursement?.numeroDossier)) {

                            remboursement.topLien = true

                            seenIds.add(remboursement.numeroDossier)
                        }
                    })
                }

                setRemboursements(remboursementsFromServer)

            } catch (err) {
                console.log("err", err)
            } finally {
                setDisabledForm(false)
            }
        }

        fetchRemboursement()

    }, [])

    useEffect(() => {

        const fetchLiens = async () => {

            const remboursementsWithTop = remboursements.filter(({ topLien }) => topLien)

            const newliensDocuments = []

            // console.log("remboursementsWithTop")
            // console.log(remboursementsWithTop)

            for (const { numeroDossier, numeroContrat, annee } of remboursementsWithTop) {

                const numeroSinistre = buildNumeroSinistre(numeroDossier, annee)

                const responseLien = await getDocumentSinistre(numeroContrat, numeroSinistre)

                console.log("#########################")
                console.log("responseLien")
                console.log(responseLien)

                if (responseLien?.length > 0) {

                    responseLien.forEach(document => {
                        newliensDocuments.push({
                            numeroDossier: numeroDossier,
                            docDate: document?.docDate,
                            lien: document?.lien,
                            libelle: document?.libelle,
                            extension: document?.extension.trim(),
                        })

                    })
                }

                // if(responseLien?.[0]?.lien) {
                //
                //     const refDocument = responseLien?.[0]
                //
                //     newliensDocuments.push({
                //         numeroDossier: numeroDossier,
                //         docDate: refDocument?.docDate,
                //         lien: refDocument?.lien,
                //         libelle: refDocument?.libelle,
                //         extension: refDocument?.extension,
                //     })
                // }
            }

            setLiensDocuments(newliensDocuments)
        }

        fetchLiens()

    }, [remboursements])

    console.log("liensDocuments")
    console.log(liensDocuments)

    useEffect(() => {

        const fetchLinesDocumentsTicDoc = async () => {

            const liensTicDoc = await getDocumentsTicDoc(contrat?.numeroContrat)

            setLiensDocumentTicDoc(liensTicDoc)
        }

        fetchLinesDocumentsTicDoc()

    }, [])

    const getLienPdf = (refDocument) => {

        return (
            <button
                className={ 'btn btn-primary btn-sm' }
                onClick={ () => displaysDocument(refDocument) }
            >
                Voir
            </button>
        )
    }

    const getLienPdfs = (refDocuments) => {

        return (
            <button
                className={ 'btn btn-primary btn-sm' }
                onClick={ () => displaysDocuments(refDocuments) }
            >
                Voir
            </button>
        )
    }

    const displaysDocuments = async (refDocuments) => {

        setDisplayDocuments(true)
        setPdfsTitle(`Documents du dossier ${ refDocuments?.[0]?.numeroDossier }`)
        setPdfLength(refDocuments?.length)

        const newPdfs = []

        if (refDocuments?.length > 0) {

            for (const document of refDocuments) {

                console.log("document")
                console.log(document)

                try {

                    const response = await getPdfBase64(document?.lien?.replaceAll('/', '-'))

                    setPdfDonwloaded(prevState => prevState + 1)

                    const newPdf = {

                        titre: `${ document?.libelle } ${ document?.docDate?.replaceAll("/", "-") } `,
                        downloadName: `${ document?.libelle } ${ document?.docDate?.replaceAll("/", "-") }.${ document?.extension.trim() }`,
                        base64: response?.pdfBase64,
                        loaded: true
                    }

                    newPdfs?.push(newPdf)

                } catch (err) {
                    console.log("err", err)
                }


            }

        }

        setPdfs(newPdfs)
        setPdfLoaded(true)
    }

    const displaysDocument = async (refDocument) => {

        setDisplayDocument(true)

        setPdf((prev) => ({
            ...prev,
            titre: refDocument?.libelle,
            downloadName: `${ refDocument?.libelle }.${ refDocument?.extension.trim() }`,
        }))

        try {

            const response = await getPdfBase64(refDocument?.lien?.replaceAll('/', '-'))

            setPdf(prev => ({
                ...prev,
                base64: response?.pdfBase64,
                loaded: true,
            }))

        } catch (err) {
            console.log("err", err)

            setPdf(prev => ({
                ...prev,
                loaded: true
            }))
        }
    }

    const closeModal = () => {

        setDisplayDocument(false)
        setPdf(prev => ({
            ...prev,
            base64: null,
            loaded: false,
            titre: null,
            downloadName: null,
        }))

        // FIXME provisoire
        setDisplayDocuments(false)
        setPdfLoaded(false)
        setPdfDonwloaded(0)
    }

    const RemboursementsTable = ({ data: remboursements }) => {

        return (
            <div className='table-responsive'>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th className="text-center">N° Dossier</th>
                        <th className="text-center">Début période d'indémnisation</th>
                        <th className="text-center">Fin période d'indémnisation</th>
                        <th className="text-center">Ouverture période (des 2 ans)</th>
                        <th className="text-center">Fin période (des 2 ans)</th>
                        <th className="text-center">Jours consommés</th>
                        <th className="text-center">Jours restants</th>
                        <th className="text-center">Date de paiement</th>
                        <th className="text-center">Montant en €</th>
                        <th className="text-center">Réouverture des droits</th>
                        <th className="text-center">Documents</th>
                    </tr>
                    </thead>
                    <tbody>
                    { remboursements?.length > 0 && remboursements.map(remboursement => {

                        const refDocument = remboursement?.topLien ? liensDocuments?.find(({ numeroDossier }) => numeroDossier === remboursement?.numeroDossier) : false
                        const refDocuments = remboursement?.topLien ? liensDocuments?.filter(({ numeroDossier }) => numeroDossier === remboursement?.numeroDossier) : false

                        // if (remboursement?.topLien) {
                        //     console.log("refDocument")
                        //     console.log(refDocument)
                        //     console.log("refDocuments")
                        //     console.log(refDocuments)
                        // }

                        return (
                            <tr key={ uuidv4() }>
                                <td className="text-center">{ remboursement?.numeroDossier }</td>
                                <td className="text-center">{ remboursement?.dateDebutDcpt }</td>
                                <td className="text-center">{ remboursement?.dateFinDcpt }</td>
                                <td className="text-center">{ remboursement?.dateOuverturePeriode }</td>
                                <td className="text-center">{ remboursement?.dateFinPeriode }</td>
                                <td className="text-center">{ remboursement?.nombreJoursConsommes }</td>
                                <td className="text-center">{ remboursement?.nombreJoursRestants }</td>
                                <td className="text-center">{ remboursement?.datePaiement }</td>
                                <td className="text-center">{ remboursement?.montant }</td>
                                <td className="text-center">{ remboursement?.datePrevReouvertureDroits }</td>
                                <td className="text-center">
                                    {/*{ (remboursement?.topLien && refDocument?.lien) ? getLienPdf(refDocument) : <>-</>}*/}
                                    { (remboursement?.topLien && refDocument?.lien) ? getLienPdfs(refDocuments) : <>-</>}
                                </td>
                            </tr>
                        )
                    }) }

                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className="container demande-indemnisation-container mt-3">

            <SecondaryNavBar activePage='remboursements'/>

            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className="card">
                    <div className="card-header">
                        { contrat?.gammeContrat === "SANTE" ? 'Allocations complémentaires' : 'Indémnisations' }
                    </div>

                    <div className="card-body">
                        <PaginationWithTable
                            key={ remboursements?.length }
                            records={ remboursements }
                            recordsPerPage={ 20 }
                            TableComponent={ RemboursementsTable }
                        />
                    </div>

                    <div className="card-footer d-flex align-items-center justify-content-between">
                        { liensDocumentTicDoc?.length > 0 && (
                            <div>
                                <ul className={ 'list-group' }>
                                    { liensDocumentTicDoc.map(lien => (
                                        <li className='list-group-item list-group-item-action' key={ lien?.id }>
                                            { lien?.libelle }

                                            <button
                                                key={ lien?.id }
                                                className="btn btn-primary btn-sm ms-3"
                                                onClick={ () => displaysDocument(lien) }
                                            >
                                                Voir
                                            </button>

                                        </li>
                                    )) }
                                </ul>
                            </div>
                        )}
                        <button
                            onClick={ () => navigate(ROUTES?.PAGES?.FICHE_PERSONNE) }
                            type={ 'button' }
                            className="btn btn-secondary mt-0 ml-auto">
                            Retourner sur la fiche personne
                        </button>
                    </div>
                </div>

                <Modal
                    show={ displayDocuments }
                    size={ 'xl' }
                    onHide={ closeModal }
                >
                    <Modal.Header>
                        <h3  dangerouslySetInnerHTML={ {
                            __html: DOMPurify.sanitize(pdfsTitle)
                        } }/>
                    </Modal.Header>

                    <Modal.Body>

                        <h4>
                            Documents chargés : { pdfsDonwloaded } / { pdfsLength }
                        </h4>

                        { (pdfsLoaded && pdfs?.length > 0) && pdfs?.map(pdf => (
                            <div key={ getUuid() } className={ "mt-3" }>
                                Télécharger :&nbsp;
                                <a
                                    className={ '' }
                                    href={ displayBase64Pdf(pdf?.base64) }
                                    download={ pdf?.downloadName }
                                    dangerouslySetInnerHTML={ {
                                        __html: DOMPurify.sanitize(`${ pdf?.downloadName }`)
                                    } }/>
                            </div>
                        )) }


                    </Modal.Body>

                    <Modal.Footer>

                        <div className={ '' }>
                            <button
                                type="button"
                                className="btn btn-secondary ms-3"
                                onClick={ closeModal }
                            >
                                Fermer le document
                            </button>
                        </div>

                    </Modal.Footer>
                </Modal>

                <PdfModal
                    displayDocument={ displayDocument }
                    closeModal={ closeModal }
                    title={ pdf?.titre }
                    base64={ pdf?.base64 }
                    fileName={ pdf?.downloadName }
                    loaded={ pdf?.loaded }
                />
            </main>
        </div>
    )
}